import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

const statuses = [
  { k: "present", label: "Present", color: "var(--success)" },
  { k: "half_day", label: "Half Day", color: "var(--warning)" },
  { k: "leave", label: "Leave", color: "var(--secondary)" },
  { k: "absent", label: "Absent", color: "var(--error)" },
];

export default function Attendance() {
  const [staff, setStaff] = useState([]);
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [rows, setRows] = useState({});

  const load = async () => {
    const [s, a] = await Promise.all([api.get("/staff"), api.get("/attendance", { params: { date } })]);
    setStaff(s.data);
    const map = {};
    a.data.forEach((r) => (map[r.staff_id] = r.status));
    setRows(map);
  };
  useEffect(() => { load(); }, [date]);

  const mark = async (staff_id, status) => {
    setRows((r) => ({ ...r, [staff_id]: status }));
    try {
      await api.post("/attendance", { staff_id, date, status });
      toast.success("Marked");
    } catch { toast.error("Failed"); }
  };

  return (
    <div className="p-6 md:p-10 max-w-6xl mx-auto" data-testid="attendance-root">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-display font-bold text-3xl">Attendance</h1>
        <input data-testid="attendance-date" type="date" value={date} onChange={(e) => setDate(e.target.value)} className="h-12 px-3 rounded-md border bg-white" style={{ borderColor: "var(--border-soft)" }} />
      </div>

      <div className="card-soft">
        {staff.length === 0 && <div className="p-10 text-center" style={{ color: "var(--text-muted)" }}>No staff added yet.</div>}
        {staff.map((s) => (
          <div key={s.id} className="flex items-center gap-4 p-4 border-t first:border-t-0" style={{ borderColor: "var(--border-soft)" }} data-testid={`attendance-row-${s.phone}`}>
            <div className="flex-1">
              <div className="font-medium">{s.name}</div>
              <div className="text-xs" style={{ color: "var(--text-muted)" }}>{s.role}</div>
            </div>
            <div className="flex flex-wrap gap-2">
              {statuses.map((st) => (
                <button key={st.k} onClick={() => mark(s.id, st.k)} data-testid={`att-${s.phone}-${st.k}`} className="h-10 px-4 rounded-md text-sm font-semibold border" style={{ borderColor: rows[s.id] === st.k ? st.color : "var(--border-soft)", background: rows[s.id] === st.k ? st.color : "white", color: rows[s.id] === st.k ? "white" : "var(--text-main)" }}>
                  {st.label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
